<script>
// @ts-check
import * as R from 'ramda'
import { mapState, mapMutations, mapGetters } from 'vuex'
import { Maybe, Metrics, Wizard } from '@domain' // eslint-disable-line
import ChartIntroComponents from '@components/chartIntros'

export default {
  page: {
    title: 'Data categories',
    meta: [{ name: 'description', content: 'choose data categories page...' }],
  },
  data() {
    return {
      selectedOptions: [],
    }
  },
  computed: {
    validChoose() {
      return this.selectedOptions.length > 0
    },
    ...mapState('wizard', {
      options(state) {
        return R.pipe(
          R.chain(cType => cType.getMetrics()),
          Maybe.valueOrDefault([])
        )(state.chartType)
      },
      /** @param {Wizard} state
       *  @returns {Maybe<Array<Metrics>>}
       */
      categoryChosen(state) {
        return Maybe.of(R.map(Metrics.Metrics, this.selectedOptions))
      },
    }),
    ...mapGetters('wizard', ['wizardNextRoute']),
  },
  ...mapState('wizard', {
    /**
     * @param {Wizard} state
     */
    mounted(state) {
      this.selectedOptions = R.map(m => m[0], state.metrics[0] || [])
    },
  }),
  methods: {
    selectMetric: function(opt) {
      if (this.isCartChecked(opt)) {
        this.selectedOptions = R.reject(o => o === opt, this.selectedOptions)
      } else {
        this.selectedOptions.push(opt)
      }
    },
    saveAndNext: function() {
      this.save(this.categoryChosen)
      this.$router.push({ path: this.wizardNextRoute })
    },
    ...mapMutations('wizard', {
      save: 'SetMetrics',
    }),
    isCartChecked(opt) {
      return this.selectedOptions.some(s => s === opt)
    },
  },
}
</script>

<template>
  <v-layout
    column
    class="iefix">
    <v-flex class="mt-5">
      <span
        class="section-title-font section-title-font-weight"
      >Which categories do you want to see displayed? (Choose up to {{ options.length }})</span>
      <!-- <span class="section-title-font">(Choose up to {{ options.length }})</span> -->
    </v-flex>
    <v-flex>
      <v-layout
        justify-start
        row>
        <v-flex
          v-for="(option,index) in options"
          :key="index"
          d-inline-flex
          class="mt-5 mb-5 pr-5"
          fill-height
          xs3
          @click="selectMetric(option)"
        >
          <v-card
            :class="{'active-card': isCartChecked(option) }"
            hover
            height="160">
            <v-card-text>{{ option }}</v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-divider/>
    <v-flex mt-3>
      <v-layout
        class="nav-btn"
        row
        justify-end>
        <v-flex xs2>
          <v-layout justify-end>
            <!-- <v-flex xs10> -->
            <v-btn
              :disabled="!validChoose"
              large
              block
              style="background-color: #243f92"
              @click="saveAndNext()"
            >Generate Graph</v-btn>
            <!-- </v-flex> -->
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<style scoped>
.section-title-font {
  display: inline-block;
  font-size: 32px;
  color: #707070;
}
.section-title-font-weight {
  font-weight: bold;
}
.nav-btn >>> .btn {
  min-width: 130px;
}
</style>

<style lang='scss' scoped>
.card {
  display: flex;
  align-items: center;
  > .card__text {
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    color: #707070;
  }
}
.active-card {
  background: linear-gradient(to right, #11a0b0, #4bc2c7);

  > .card__text {
    color: white;
  }
}
.disabled-card {
  border: 1px solid #e0e0e0;
  box-shadow: none;
  cursor: unset;

  > .card__text {
    color: #e0e0e0;
  }
}


</style>
